/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ProductRoleAssignmentsInput = {
  productId: string;
  roleId: string;
};

export type UserCreateInput = {
  displayName?: string | null | undefined;
  email: string;
  memo?: string | null | undefined;
  organizationShortCode: string;
  productRoleAssignments: Array<ProductRoleAssignmentsInput>;
  userGroupIds: Array<string>;
  userSegmentIds: Array<number>;
};

export type AddUserMutationVariables = Exact<{
  input: Types.UserCreateInput;
}>;


export type AddUserMutation = { cnutCreateUser: { __typename: 'UserCreateOutput', id: string } };


export const AddUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutCreateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddUserMutation, AddUserMutationVariables>;